import { FacetListDTO, ListItem } from "./filters.type";
import { filterKeysByOrder } from "./filterKeysByOrder";

export const mapFacetList = (result: FacetListDTO) => {
  const facetNames = Object.keys(result).filter(
    (item) => item !== "degradedServices"
  );
  const topLevelFilters = facetNames
    .map((facet: string) => {
      const facetType = result[facet] as ListItem[];
      return facetType.map((details: ListItem) => ({
        label: details.label,
        type: details.type,
        key: details.key,
        parentFilterKey:
          details.key === "Model" ? "Make" : details.parentFacetKey,
      }));
    })
    .flat();

  // Create new ordered array based upon the filterKeysByOrder...
  const orderedFilters = [];
  filterKeysByOrder.forEach((key: string) => {
    const foundItem = topLevelFilters.find((item) => item.key === key);
    if (foundItem) {
      orderedFilters.push(foundItem);
    }
  });

  return { facetList: orderedFilters };
};
